import { View } from 'backbone.marionette';
import Radio from 'backbone.radio';
import { Secret } from "../../../utils";

const rankingsChannel = Radio.channel( 'Rankings' );
const IS_PRE_SEASON = Secret.is_passed ? false : JSON.parse(process.env.IS_PRE_SEASON);

/**
 * @desc Core RankingsTipping Header Class
 */
export class CoreRankingsHeader extends View {
	get className() {
		return "rankings-header";
	}

	ui() {
		return {
			change_states: '.js-change-states',
			change_round:  '.js-change-round',
			change_clubs:  '.js-change-clubs',
			change_month:  '.js-change-month',
			sort_column:   '.js-sort-column'
		};
	}

	events() {
		return {
			'change @ui.change_states': 'updateRankings',
			'change @ui.change_round': 'updateRankings',
			'change @ui.change_clubs': 'updateRankings',
			'change @ui.change_month': 'updateRankings',
			'click @ui.sort_column': 'sortColumn'
		};
	}

	initialize() {
		this.rounds = this.getOption('rounds');

		this.model.set({
			month: '',
			months: [],
			is_preseason: IS_PRE_SEASON
		});
		this.initListeners();
	}

	initListeners() {
		this.listenTo( rankingsChannel, 'rankings:model:updated', this.render );
		this.listenTo( rankingsChannel, 'rankings:initial_squad', this.setInitialSquad );

		return this;
	}

	setInitialSquad(squad_id) {
		this.getUI( 'change_clubs' ).val(squad_id);
	}

	sortColumn( element ) {
		let { order_direction, round, order } = this.model.attributes;

		let data = {
			order: $(element.currentTarget).data( 'order' ),
			order_direction: order_direction === 'ASC' ? 'DESC' : 'ASC'
		};

		if (order !== data.order) {
			const invert_order_array = ['rank', 'team_name', 'coach'];
			data.order_direction = invert_order_array.includes(data.order) ? 'ASC' : 'DESC';
		}

		if( round ) {
			data = {
				...data,
				round
			}
		}

		this.updateModel( data );
	}

	updateRankings() {
		this.model.set( {
			offset: 0,
			round: this.getUI( 'change_round' ).val()
		} );

		let data = {
			round: this.getUI( 'change_round' ).val(),
			club:  this.getUI( 'change_clubs' ).val(),
			state: this.getUI( 'change_states' ).val(),
			month: this.getUI( 'change_month' ).val(),
			order: this.model.get( 'order' ),
			offset: 0
		};

		this.updateModel( data );
	}

	updateModel( data ) {
		this.model.set( data );
		rankingsChannel.trigger( 'rankings:update', data );
		this.render();
	}
}

export default CoreRankingsHeader;